import React, { createContext, useContext } from "react";
import ExportService from "./export.service";

const ExportServiceContext = createContext(ExportService);


export const ExportServiceProvider = ({ children }) => (
  <ExportServiceContext.Provider value={ExportService}>
    {children}
  </ExportServiceContext.Provider>
);

export const useExportService = () => useContext(ExportServiceContext);
